import * as React from 'react';
import cx from 'clsx';

import { useDeviceRatio } from '../../hooks/useDeviceRatio';
import { NavigationBack as NavigationBackIcon } from '../icons';
import styles from './HeaderBar.module.scss';
import { HeaderProps } from './types';

interface HeaderBarProps {
  heading: HeaderProps['title'];
  headingElement?: HeaderProps['headingElement'];
  backButtonText: HeaderProps['backButtonText'];
  onBackButtonClick: HeaderProps['onBackButtonClick'];
  headerBackground?: HeaderProps['headerBackground'];
  backButtonHidden?: HeaderProps['backButtonHidden'];
}

const HeaderBar: React.FC<HeaderBarProps> = ({
  heading,
  headingElement = 'h1',
  backButtonText,
  onBackButtonClick,
  headerBackground,
  backButtonHidden = false,
}) => {
  const windowRatio = useDeviceRatio().ratio;
  let headerBackgroundToUse = '';
  if (headerBackground) {
    headerBackgroundToUse =
      windowRatio === 2 ? headerBackground.image2x : headerBackground.image;
  }

  return (
    <div
      className={cx(
        styles.wrapper,
        backButtonHidden
          ? styles.wrapperBackButtonHidden
          : styles.wrapperBackButtonVisible
      )}
      style={
        headerBackground && { backgroundImage: `url(${headerBackgroundToUse}` }
      }
      data-testid="header-content-wrapper"
    >
      {!backButtonHidden && (
        <div
          className={styles.back}
          data-testid="header-back-button"
          onClick={onBackButtonClick}
        >
          <NavigationBackIcon className={styles.navigationBack} />
          <p className={styles.text}>{backButtonText}</p>
        </div>
      )}
      {React.createElement(
        headingElement,
        { className: styles.heading },
        heading
      )}
    </div>
  );
};

export default HeaderBar;
